export default __webpack_public_path__ + "static/media/imagem-clinica-hospital.8c8cddfa.jpg";